import React from 'react';
// From general.js
/* global scrollToPageTop */
/* eslint-disable react/prop-types */

import Sticky from 'react-sticky-el';
import { Svg } from '../common/Svg.js';
import MapCalloutPoint from '../../../images/donor-map/map-callout-point.svg';

// TODO: Kind of working, but needs better styling
let MobileSearchHeader = (props) => {
    return (
        <div className="search-header-container">
            <Sticky stickyClassName='sticky-search-header' boundaryElement="body" topOffset={160}>
                <div className="search-header" onClick={scrollToPageTop}>
                    <a className="browse-toggle map-search" href={props.targetUrl} tabIndex="0">
                        <strong><Svg icon="location" attributes={{ role: 'presentation' }} /> Map</strong>
                    </a>
                    <a className="browse-toggle" onClick={props.openFiltersView} tabIndex="0">
                        <strong><Svg icon="search" attributes={{ role: 'presentation' }} /> Search</strong>
                    </a>
                </div>
            </Sticky>
            <a className="map-placeholder" href={props.targetUrl} tabIndex="0"></a>
            <div className="underlying-project-points">
                <MapCalloutPoint className="fourth" />
                <MapCalloutPoint className="third"/>
                <MapCalloutPoint className="second"/>
                <MapCalloutPoint className="fourth"/>
                <MapCalloutPoint className="first"/>
                <MapCalloutPoint className="first"/>
                <MapCalloutPoint className="second" />
                <MapCalloutPoint className="third"/>
                <MapCalloutPoint className="second"/>
                <MapCalloutPoint className="fourth"/>
                <MapCalloutPoint className="third"/>
                <MapCalloutPoint className="second"/>
                <MapCalloutPoint className="third"/>
            </div>
        </div>
    );
};
MobileSearchHeader = React.memo(MobileSearchHeader);
export default MobileSearchHeader;
